<img class="w-full pb-2" src="../../../../assets/maintenance/Souzou-WebSite-Management-silver-flat-1.svg" alt="Logo" width="200" height="80">
